import React from 'react';
import './Home.css';
import ProfileSide from '../../components/profileSide/ProfileSide';
import PostSide from '../../components/PostSide/PostSide';
import RightSide from '../../components/RightSide/RightSide';

const Home = () => {
  // Determine the screen size
  const screenWidth = window.innerWidth;

  // Define breakpoints for different screen sizes
  const mobileBreakpoint = 767; // Adjust as needed
  const tabletBreakpoint = 1024; // Adjust as needed

  // Conditionally render components based on screen size
  if (screenWidth <= mobileBreakpoint) {
    // Render for mobile screens
    return (
      <div className='Home'>
        <ProfileSide />
        <PostSide />
        <RightSide />
      </div>
    );
  } else if (screenWidth <= tabletBreakpoint) {
    // Render for tablet screens
    return (
      <div className='Home'>
        <ProfileSide />
        <div className='tablet-layout'>
          <PostSide />
          <RightSide />
        </div>
      </div>
    );
  } else {
    // Render for desktop screens
    return (
      <div className='Home'>
        <ProfileSide />
        <div className='desktop-layout'>
          <PostSide />
          <RightSide />
        </div>
      </div>
    );
  }
};

export default Home;
